module.exports = __webpack_public_path__ + "img/speech_2.2364ca9a.jpeg";